
import { get_cookie } from '/srv/web/wyvr/html/releases/58819/gen/client/odoscope/api/get_cookie.js?1733898722586';
import { set_cookie } from '/srv/web/wyvr/html/releases/58819/gen/client/odoscope/api/set_cookie.js?1733898722586';
import { send_tracking_event } from '/srv/web/wyvr/html/releases/58819/gen/client/odoscope/tracking/send_tracking_event.js?1733898722586';
import { send_result_tracking_event } from '/srv/web/wyvr/html/releases/58819/gen/client/odoscope/tracking/send_result_tracking_event.js?1733898722586';
import { object_to_query_param } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/url.js?1733898722586';
import { get_cookie_name } from '/srv/web/wyvr/html/releases/58819/gen/client/odoscope/api/get_cookie_name.js?1733898722586';
import { logger } from '@wyvr/generator/universal.js';

/**
 * Load product decisions from odoscope
 *
 * @param {Object} config - The configuration options for loading decisions.
 * @param {string} site_id - The ID of the site.
 * @param {string} token - The token for authentication.
 * @param {number} [timeout=150] - The timeout value in milliseconds.
 * @returns {Promise<[?Error, ?OdoscopeAnswer]>} - A promise that resolves to an array containing an error object and the loaded decisions object.
 */
export async function load_decisions(config, site_id, token, timeout = 400) {
    const load_products_data = true;
    try {
        const controller = new AbortController();
        // build the config
        const fallback_useragent = 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_4_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.3.1 Mobile/15E148 Safari/604.1';
        const data = {
            ua: true ? window?.navigator?.userAgent ?? fallback_useragent : fallback_useragent,
            ref: true ? document?.referrer ?? '' : ''
        };
        // apply all options to the odoscope request
        for (const [key, value] of Object.entries(config)) {
            if (value === undefined) {
                continue;
            }
            data[key] = value;
        }
        data.token = token;
        data.maxItems = Number.parseInt("5000") || 5000;
        data.isShortAnswer = !load_products_data;

        const cookie = get_cookie(token);
        if (cookie) {
            data[get_cookie_name(token)] = cookie;
        }

        const options = {
            method: 'GET',
            redirect: 'follow',
            signal: controller.signal
        };

        const guard = setTimeout(() => {
            logger.error('abort odoscope request after timeout', timeout);
            send_tracking_event('odoscope/timeout', token);
            controller.abort();
        }, timeout);

        const osc_url = `https://odoscope.cloud/${site_id}/decisions${object_to_query_param(data)}`;
        const response = await fetch(osc_url, options);

        clearTimeout(guard);

        if (!response.ok) {
            send_tracking_event('odoscope/error', token);
            return [{ code: response.status, text: response.statusText }, undefined];
        }
        const result = await response.json();

        const tracking_id = result?.oscTracking || token;

        // set the cookie
        set_cookie(result.oscCookie, token);

        // send tracking event
        send_result_tracking_event(result, tracking_id);

        return [undefined, result];
    } catch (e) {
        return [e, undefined];
    }
}
